export default __webpack_public_path__ + "static/media/lola.07e4c27c.png";